import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Msg, Button } from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import Http from 'services/http2';
import User from 'services/user2';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import CompanyService from 'services/company2';
//审批流状态
import WorkflowStatus from 'components/workflowStatus.jsx';
//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';
import Util from 'lib/util.js';
import useDetail from 'hooks/useDetail';
import BillingService from 'services/billing';
import { ActionContext } from 'actions/context';
import Modal from 'components/modal';
import ModalService from 'services/modal';
import CommonFns from 'functions/common.ts';
import Big from 'big.js';
import ESignService from 'services/esign';

function StatementDetailDetail(props) {
  const Config = {
    sale: {
      title: '客户对账单详情',
      apiPath: '/statementOrder/getDetail',
      deliveryListApiPath: '/statementOrderDeliverys/mobileGetPageList',
      vmiListApiPath: '/statementOrderVmiDeliverys/mobileGetPageList',
      returnListApiPath: '/statementOrderReturns/getPrintList',
      costListApiPath: '/statementOrderCost/getPrintList',
      prepayListApiPath: '/statementOrderPrepay/getPrintList',
      statisticAmountApiPath: '/statementOrder/getStatisticAmount',
      confirmApiPath: '/statementOrder/confirm',
      returnApiPath: '/statementOrder/returnState',
      publishApiPath: '/statementOrder/publish',
      revokeApiPath: '/statementOrder/revoke',
      abandonApiPath: '/statementOrder/abandon',
      deleteApiPath: '/statementOrder/delete',
      listRouter: '/mp/sale/billing/statement/list',
      customerNameKey: 'customerPrintName',
      vendorNameKey: 'companyName',
      arrEnumField: [
        {
          mainKey: 'B02_Reco_Status',
          subKey: 'status',
          value: 'statusName'
        },
        {
          mainKey: 'B02_Purchase_Type',
          subKey: 'purchaseType',
          value: 'purchaseTypeName'
        }
      ],
      idField: 'recoXkNo'
    },
    purchase: {
      title: '供应商对账单详情',
      apiPath: '/vStatementOrder/getDetail',
      deliveryListApiPath: '/vStatementOrderDeliverys/getPageList',
      vmiListApiPath: '/vStatementOrderVmiDeliverys/mobileGetPageList',
      returnListApiPath: '/vStatementOrderReturns/getPrintList',
      costListApiPath: '/vStatementOrderCost/getPrintList',
      prepayListApiPath: '/vStatementOrderPrepay/getPrintList',
      statisticAmountApiPath: '/vStatementOrder/getStatisticAmount',
      confirmApiPath: '/vStatementOrder/confirm',
      returnApiPath: '/vStatementOrder/returnState',
      publishApiPath: '/vStatementOrder/publish',
      revokeApiPath: '/vStatementOrder/revoke',
      abandonApiPath: '/vStatementOrder/abandon',
      deleteApiPath: '/vStatementOrder/delete',
      confirmQtyApiPath: '/vStatementOrder/confirmQty',
      listRouter: '/mp/purchase/billing/statement/list',
      customerNameKey: 'companyName',
      vendorNameKey: 'innerVendorName',
      arrEnumField: [
        {
          mainKey: 'B02_Reco_Status',
          subKey: 'status',
          value: 'statusName'
        },
        {
          mainKey: 'B02_Purchase_Type',
          subKey: 'purchaseType',
          value: 'purchaseTypeName'
        }
      ],
      idField: 'recoXkNo',
      wfmCode: '1001'
    }
  };

  const config = Config[props.type];

  const {
    companyCode,
    inited,
    error,
    updateTs,
    redirect,
    moreSign1,
    moreSign2,
    handleMore,
    decimalPlace,
    fileList,
    setShowLoading,
    setError,
    setFileList,
    setRedirect,
    detail,
    setDetail,
    workflow,
    forceUpdate,
    self
  } = useDetail(props, config);

  const { state, dispatch } = useContext(ActionContext);
  const [boxState, setBoxState] = useState({
    1: true,
    2: true,
    3: true,
    4: true,
    5: true
  });
  const [deliveryData, setDeliveryData] = useState({}); //收货明细
  const [vmiDeliveryData, setVmiDeliveryData] = useState({}); //收货明细（VMI）
  const [returnData, setReturnData] = useState({}); //仓退明细
  const [costData, setCostData] = useState({}); //应收折让明细
  const [prepayData, setPrepayData] = useState({}); //预付款明细
  const [amounts, setAmounts] = useState({}); //对账单合计

  const [canRecall, setCanRecall] = useState(false); //客户对账单是否可以撤回
  const [companyParams, setCompanyParams] = useState({});

  //处理详情数据
  self.afterGetDetail = function (data) {
    if (self.isPurchase) {
      getCompanyParams(data.companyCode);
    } else {
      getWorkflowList({
        customerCode: data.customerCode,
        customerXkUniqueCode: data.customerXkUniqueCode,
        recoXkNo: data.recoXkNo
      });
      getCompanyParams(data.customerCode);
    }
    data.buyerCodesShow = data.buyerCodes
      ? JSON.parse(data.buyerCodes)
          .map(item => item.buyerName)
          .join('、')
      : '';
    setDetail(data);
    getDeliveryList();
    getVmiList();
    getReturnList();
    getCostList();
    getPrepayList();
    getStatisticAmount();
  };

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);

    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  // 收货明细
  function getDeliveryList() {
    if (!companyCode) {
      return;
    }
    let postbody = {
      companyCode: companyCode,
      recoXkNo: self.id,
      searchKey: '',
      storeAndReconPriceDiffFlag: 0,
      unEsign: 0,
      purchaseTypeList: undefined,
      apiPath: config.deliveryListApiPath
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let data = { ...response.data };
        setDeliveryData(data);
      }
    });
  }

  function handleBoxState(idx) {
    boxState[idx] = !boxState[idx];
    setBoxState(boxState);
    forceUpdate();
  }

  // 收货明细(VMI)
  function getVmiList() {
    if (!companyCode) {
      return;
    }
    let postbody = {
      companyCode: companyCode,
      recoXkNo: self.id,
      apiPath: config.vmiListApiPath
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let data = { ...response.data };
        setVmiDeliveryData(data);
      }
    });
  }

  // 仓退明细
  function getReturnList() {
    if (!companyCode) {
      return;
    }
    let postbody = {
      companyCode: companyCode,
      recoXkNo: self.id,
      apiPath: config.returnListApiPath
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let data = { ...response.data };
        setReturnData(data);
      }
    });
  }
  // 应收折让明细
  function getCostList() {
    if (!companyCode) {
      return;
    }
    let postbody = {
      companyCode: companyCode,
      recoXkNo: self.id,
      apiPath: config.costListApiPath
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let data = { ...response.data };
        setCostData(data);
      }
    });
  }
  // 预付款明细
  function getPrepayList() {
    if (!companyCode) {
      return;
    }
    let postbody = {
      companyCode: companyCode,
      recoXkNo: self.id,
      apiPath: config.prepayListApiPath
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let data = { ...response.data };
        setPrepayData(data);
      }
    });
  }

  // 对账单明细
  function getStatisticAmount() {
    if (!companyCode) {
      return;
    }
    let postbody = {
      companyCode: companyCode,
      recoXkNo: self.id,
      apiPath: config.statisticAmountApiPath
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let data = { ...response.data };
        data.tax = Big(data.totalRecoTaxAmount || 0).minus(
          data.totalRecoAmount || 0
        );
        data.confirmTax = Big(data.totalConfirmTaxAmount || 0).minus(
          data.totalConfirmAmount || 0
        );
        setAmounts(data);
      }
    });
  }

  // 确认
  async function handleConfirm() {
    let openEsign;

    if (self.isPurchase) {
      await ESignService.checkOpenFlag(
        companyCode,
        detail.vendorXkUniqueCode,
        '4'
      ).then(rs => {
        openEsign = rs.isOpen && rs.isAuto && !rs.isAlowMobile;
      });
      if (openEsign) {
        ModalService.showError(
          '已开启自动签章，请到PC端订单详情确认',
          dispatch
        );
        return;
      }
    } else {
      await ESignService.checkOpenFlag(
        companyCode,
        detail.customerXkUniqueCode,
        '4',
        false,
        detail.customerCode
      ).then(rs => {
        openEsign = rs.isOpen && rs.isAuto && !rs.isAlowMobile;
      });

      if (openEsign) {
        ModalService.showError(
          '客户已开启自动签章，请到PC端订单详情确认',
          dispatch
        );
        return;
      }
    }

    let postbody = getPostbody(config.confirmApiPath);
    BillingService.confirmVendorStatement(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //退回
  async function handleReject() {
    let postbody = getPostbody(config.returnApiPath);
    BillingService.rejectVendorStatement(
      postbody,
      () => {
        dispatch({ type: 'hideReject' });
        self.getDetail();
      },
      dispatch
    );
  }

  //数量确认
  function confirmQty() {
    let postbody = getPostbody(config.confirmQtyApiPath);
    BillingService.confirmQty(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //确认发出
  function publish() {
    if (!self.isPurchase) {
      if (companyParams['Statement_Balance_Due_Written_By']) {
        if (Util.isEmpty(detail.lastMonthUnpaidAmount)) {
          ModalService.showError('上月应付余额不能为空', dispatch);
          return;
        }
        if (Util.isEmpty(detail.currentMonthUnpaidAmount)) {
          ModalService.showError('本月应付余额不能为空', dispatch);
          return;
        }
      }
    }
    let postbody = getPostbody(config.publishApiPath);
    BillingService.publishVStatement(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //删除
  function handleDelete() {
    let postbody = getPostbody(config.deleteApiPath);
    BillingService.deleteVStatement(
      postbody,
      () => {
        return <Redirect to={config.listRouter} />;
      },
      dispatch
    );
  }

  //撤回
  function handleRecall() {
    let postbody = getPostbody(config.revokeApiPath);
    BillingService.recallVStatement(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //作废
  function handleCancel() {
    let postbody = getPostbody(config.abandonApiPath);
    BillingService.cancelVStatement(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  // 获取企业平台参数
  function getCompanyParams(customerCode) {
    CompanyService.getCompanyParamsByCodes(customerCode, [
      'Statement_Balance_Due_Written_By',
      'Statement_Qty_Cfm'
    ]).then(res => {
      if (Array.isArray(res)) {
        res.forEach(item => {
          if ([2, 3].includes(item.paramType)) {
            companyParams[item.paramCode] = item.paramValue === '1';
          }
          // 对账单应付余额填写方
          if (item.paramCode === 'Statement_Balance_Due_Written_By') {
            let o = Util.jsonDecode(item.paramValue);
            companyParams['Statement_Balance_Due_Written_By'] = o.type === 3;
          }
        });
        setCompanyParams(companyParams);
      }
    });
  }

  //获取审批流状态
  async function getWorkflowList(obj) {
    let workflowXkNo = ''; //开始审批流的单据
    let startWorkflow = false; //是否开始审批流且未审批
    let workflowDetailList = [
      {
        customerCode: obj.customerCode,
        customerXkUniqueCode: obj.customerXkUniqueCode,
        billXkNoList: [obj.recoXkNo]
      }
    ];
    let postbody = {
      companyCode,
      workflowDetailList,
      apiPath: '/CworkflowBills/getList'
    };
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let data = response.data[0];
        if (data) {
          workflowXkNo = data.billXkNo; //开始审批流的单据
          startWorkflow =
            [0, null].includes(data.status) && data.startFlag === 1; // 当前节点没有开始审批流 - 是开始节点;
        }
      }
    });
    setCanRecall(!workflowXkNo || startWorkflow);
  }

  //获取提交参数
  function getPostbody(apiPath) {
    let postbody = {
      recoXkNo: detail.recoXkNo,
      companyCode: companyCode,
      apiPath: apiPath
    };
    return postbody;
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      <div className="pb50">
        <div className="order-detail-block">
          <div className="order-detail-title">
            <label>基础信息</label>
          </div>
          <ul>
            <li>
              <label className="order-detail-label">
                {self.isPurchase ? '采购企业' : '客户名称'}
              </label>
              <div className="order-detail-value">
                {detail[config.customerNameKey]}
              </div>
            </li>

            <li>
              <label className="order-detail-label">供应商</label>
              <div className="order-detail-value">
                {detail[config.vendorNameKey]}({detail.innerVendorCode})
              </div>
            </li>

            <li>
              <label className="order-detail-label">对账单号</label>
              <div className="order-detail-value">{detail.recoInnerNo}</div>
            </li>
            <li>
              <label className="order-detail-label">状态</label>
              <div
                className={
                  'u-sign ' + CommonFns.getStatusClass('reco', detail.status)
                }
              >
                {detail.statusName}
              </div>
            </li>
            <li>
              <label className="order-detail-label">采购类型</label>
              <div className="order-detail-value">
                {detail.purchaseTypeName}
              </div>
            </li>
            <li>
              <label className="order-detail-label">对账类型</label>
              <div className="order-detail-value">
                {detail.purchaseStatementType2 === 0
                  ? '按入库对账'
                  : '按送货对账'}
              </div>
            </li>
            {/* 审批流状态 仅开启后才显示 */}
            {self.isPurchase && updateTs > 0 && workflow.isActive && (
              <li>
                <label className="order-detail-label">审批环节</label>
                <div className="order-detail-value">
                  <WorkflowStatus
                    companyCode={companyCode}
                    id={self.id}
                    workflow={workflow}
                    detail={detail}
                  />
                </div>
              </li>
            )}
            {/* 审批流按钮 */}
            {self.isPurchase && updateTs > 0 && workflow.isActive && (
              <li>
                <label className="order-detail-label">审批操作</label>
                <div className="order-detail-value">
                  <WorkflowButtons
                    companyCode={companyCode}
                    id={self.id}
                    workflow={workflow}
                    detail={detail}
                    onChange={() => {
                      self.getDetail();
                    }}
                  />
                </div>
              </li>
            )}
            <li className={moreSign1 ? 'hide' : ''}>
              <label className="order-detail-label">收货部门</label>
              <div className="order-detail-value">
                {detail.profitCenterName}
              </div>
            </li>
            <li className={moreSign1 ? 'hide' : ''}>
              <label className="order-detail-label">审核人</label>
              <div className="order-detail-value">{detail.checkName}</div>
            </li>
            <li className={moreSign1 ? 'hide' : ''}>
              <label className="order-detail-label">审核时间</label>
              <div className="order-detail-value">
                {formatDate(detail.checkTime, 'YYYY-MM-DD HH:mm')}
              </div>
            </li>
            <li className={moreSign1 ? 'hide' : ''}>
              <label className="order-detail-label">发布时间</label>
              <div className="order-detail-value">
                {formatDate(detail.publishTime, 'YYYY-MM-DD HH:mm')}
              </div>
            </li>
            <li className={moreSign1 ? 'hide' : ''}>
              <label className="order-detail-label">纳税人识别号</label>
              <div className="order-detail-value">
                {detail.vendorCreditCode}
              </div>
            </li>
            <li className={moreSign1 ? 'hide' : ''}>
              <label className="order-detail-label">建单人</label>
              <div className="order-detail-value">{detail.publishName}</div>
            </li>
            <li className={moreSign1 ? 'hide' : ''}>
              <label className="order-detail-label">开户行</label>
              <div className="order-detail-value">
                {detail.openAccountBankName}
              </div>
            </li>
            <li className={moreSign1 ? 'hide' : ''}>
              <label className="order-detail-label">银行账号</label>
              <div className="order-detail-value">{detail.bankCardNo}</div>
            </li>
            <li>
              <label className="order-detail-label">对账周期</label>
              <div className="order-detail-value">
                {formatDate(detail.recoStartTime, 'YYYY-MM-DD')} 至{' '}
                {formatDate(detail.recoEndTime, 'YYYY-MM-DD')}
              </div>
            </li>
            <li className={moreSign1 ? 'hide' : ''}>
              <label className="order-detail-label">币别</label>
              <div className="order-detail-value">{detail.currencyName}</div>
            </li>
            <li className={moreSign1 ? 'hide' : ''}>
              <label className="order-detail-label">采购员</label>
              <div className="order-detail-value">{detail.buyerCodesShow}</div>
            </li>
            <li className={moreSign1 ? 'hide' : ''}>
              <label className="order-detail-label">付款条件</label>
              <div className="order-detail-value">{detail.payWayName}</div>
            </li>
            <li className={moreSign1 ? 'hide' : ''}>
              <label className="order-detail-label">税率</label>
              <div className="order-detail-value">{detail.taxName}</div>
            </li>
            <li className={moreSign1 ? 'hide' : ''}>
              <label className="order-detail-label">应付凭证</label>
              <div className="order-detail-value">{detail.payCredentials}</div>
            </li>
            <li className={moreSign1 ? 'hide' : ''}>
              <label className="order-detail-label">总账凭证</label>
              <div className="order-detail-value">
                {detail.totalCredentials}
              </div>
            </li>
            <li className={moreSign1 ? 'hide' : ''}>
              <label className="order-detail-label">立账状态</label>
              <div className="order-detail-value">{detail.lzStatus}</div>
            </li>
            <li className={moreSign1 ? 'hide' : ''}>
              <label className="order-detail-label">支付方式</label>
              <div className="order-detail-value">
                {detail.paymentMethodName}
              </div>
            </li>
            <li className={moreSign1 ? 'hide' : ''}>
              <label className="order-detail-label">账款到期日</label>
              <div className="order-detail-value">
                {formatDate(detail.payExpiredDate)}
              </div>
            </li>
            <li className={moreSign1 ? 'hide' : ''}>
              <label className="order-detail-label">供应商备注</label>
              <div className="order-detail-value">{detail.vendorRemark}</div>
            </li>
            <li className={moreSign1 ? 'hide' : ''}>
              <label className="order-detail-label">备注</label>
              <div className="order-detail-value">{detail.remark}</div>
            </li>
          </ul>
          <div
            className={moreSign1 ? 'm-more' : 'm-more m-more-open'}
            onClick={() => {
              handleMore(1);
            }}
          >
            {moreSign1 && '更多'}
            {!moreSign1 && '收起'}
            <i className="icon-down"></i>
          </div>
        </div>

        {/* 收货明细 */}
        {deliveryData.pageList && !Util.isEmpty(deliveryData.pageList.list) && (
          <div className="order-detail-box">
            <div className="order-detail-block">
              <div
                className={
                  !boxState[1]
                    ? 'order-detail-title m-more'
                    : 'order-detail-title m-more m-more-open'
                }
              >
                <label>收货明细</label>
                <i className="icon-down" onClick={() => handleBoxState(1)}></i>
              </div>
              {boxState[1] === true && (
                <div className="order-detail-list">
                  <ul>
                    {deliveryData.pageList.list.map((item, index) => (
                      <li className="order-detail-item" key={index}>
                        <span className="lineNo">项次 {item.lineNo}</span>
                        <h4>
                          {item.productCode} - {item.productName}
                        </h4>
                        <p className="mb10">{item.productScale}</p>

                        <ul className="clearfix">
                          <li>
                            送货数量：
                            {formatNumber(
                              item.deliveryValuationQty,
                              decimalPlace.Quantity_Decimal_Place
                            )}
                          </li>
                          <li>
                            送货单价：
                            {formatNumber(
                              item.poIsContainTax === 1
                                ? item.deliveryTaxPrice
                                : item.deliveryPrice,
                              decimalPlace.Quantity_Decimal_Place
                            )}
                            /{item.valuationUnitName}
                          </li>
                          <li>
                            送货金额：
                            <span>
                              {formatNumber(
                                item.poIsContainTax === 1
                                  ? item.deliveryTaxAmount
                                  : item.deliveryAmount,
                                decimalPlace.Amount_Decimal_Place
                              )}
                            </span>
                          </li>
                          <li>送货日期：{formatDate(item.deliveryDate)}</li>
                          <li>
                            对账单价：
                            {formatNumber(
                              item.poIsContainTax === 1
                                ? item.curReconTaxPrice
                                : item.curReconPrice,
                              decimalPlace.Price_Decimal_Place
                            )}
                            /{item.valuationUnitName}
                          </li>
                          <li>
                            确认单价：
                            {formatNumber(
                              item.poIsContainTax === 1
                                ? item.curConfirmReconTaxPrice
                                : item.curConfirmReconPrice,
                              decimalPlace.Price_Decimal_Place
                            )}
                            /{item.valuationUnitName}
                          </li>
                          <li>
                            是否含税：
                            {item.poIsContainTax === 1 ? '含税' : '不含税'}
                          </li>
                          <li>
                            税率：
                            {item.storageTaxRate
                              ? item.storageTaxRate * 100 + '%'
                              : ''}
                          </li>
                          <li>
                            对账数量：
                            {formatNumber(
                              item.curConfirmValuationQty,
                              decimalPlace.Quantity_Decimal_Place
                            )}
                          </li>
                          <li>
                            对账含税金额：
                            <span>
                              {formatNumber(
                                item.curConfirmTaxAmount,
                                decimalPlace.Amount_Decimal_Place
                              )}
                            </span>
                          </li>
                          <li>
                            对账未税金额：
                            <span>
                              {formatNumber(
                                item.curConfirmAmount,
                                decimalPlace.Amount_Decimal_Place
                              )}
                            </span>
                          </li>
                          <li>
                            税额：
                            <span>
                              {formatNumber(
                                item.curConfirmTaxAmount -
                                  item.curConfirmAmount,
                                decimalPlace.Amount_Decimal_Place
                              )}
                            </span>
                          </li>
                          <li>
                            备注：
                            {item.remark}
                          </li>
                          <li>
                            供应商备注：
                            {item.vremark}
                          </li>
                        </ul>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
            {boxState[1] === true && (
              <div className="order-detail-block account">
                <div className="order-detail-title">
                  <label>收货明细合计</label>
                </div>
                <ul>
                  <li>
                    <label className="order-detail-label">送货数量合计</label>
                    <div className="order-detail-value">
                      {formatNumber(
                        deliveryData.deliveryTotQty,
                        decimalPlace.Quantity_Decimal_Place
                      )}
                    </div>
                  </li>
                  <li>
                    <label className="order-detail-label">含税金额合计</label>
                    <div className="order-detail-value">
                      {formatNumber(
                        deliveryData.totalCurConfirmTaxAmount,
                        decimalPlace.Amount_Decimal_Place
                      )}
                    </div>
                  </li>
                  <li>
                    <label className="order-detail-label">未税金额合计</label>
                    <div className="order-detail-value">
                      {formatNumber(
                        deliveryData.totalCurConfirmAmount,
                        decimalPlace.Amount_Decimal_Place
                      )}
                    </div>
                  </li>
                  <li>
                    <label className="order-detail-label">税额合计</label>
                    <div className="order-detail-value">
                      {formatNumber(
                        deliveryData.totalTax,
                        decimalPlace.Amount_Decimal_Place
                      )}
                    </div>
                  </li>
                </ul>
              </div>
            )}
          </div>
        )}

        {/* 收货明细（VMI） */}
        {vmiDeliveryData.pageList &&
          !Util.isEmpty(vmiDeliveryData.pageList.list) && (
            <div className="order-detail-box">
              <div className="order-detail-block">
                <div
                  className={
                    !boxState[2]
                      ? 'order-detail-title m-more'
                      : 'order-detail-title m-more m-more-open'
                  }
                >
                  <label>收货明细（VMI）</label>
                  <i
                    className="icon-down"
                    onClick={() => handleBoxState(2)}
                  ></i>
                </div>
                {boxState[2] === true && (
                  <div className="order-detail-list">
                    <ul>
                      {vmiDeliveryData.pageList.list.map((item, index) => (
                        <li className="order-detail-item" key={index}>
                          <span className="lineNo">项次 {item.lineNo}</span>
                          <h4>
                            {item.productCode} - {item.productName}
                          </h4>
                          <p className="mb10">{item.productScale}</p>

                          <ul className="clearfix">
                            <li>
                              入库数量：
                              {formatNumber(
                                item.storageValuationQty,
                                decimalPlace.Quantity_Decimal_Place
                              )}
                            </li>
                            <li>
                              入库单价：
                              {formatNumber(
                                item.isContainTax === 1
                                  ? item.storageTaxPrice
                                  : item.storagePrice,
                                decimalPlace.Price_Decimal_Place
                              )}
                            </li>
                            <li>
                              入库金额：
                              <span>
                                {formatNumber(
                                  item.isContainTax === 1
                                    ? item.storageTaxAmount
                                    : item.storageAmount,
                                  decimalPlace.Amount_Decimal_Place
                                )}
                              </span>
                            </li>
                            <li>入库日期：{formatDate(item.storageDate)}</li>
                            <li>
                              是否含税：
                              {item.isContainTax === 1 ? '含税' : '不含税'}
                            </li>
                            <li>
                              税率：
                              {item.storageTaxRate
                                ? item.storageTaxRate * 100 + '%'
                                : ''}
                            </li>
                            <li>
                              对账数量：
                              {formatNumber(
                                item.curConfirmValuationQty,
                                decimalPlace.Quantity_Decimal_Place
                              )}
                            </li>
                            <li>
                              对账含税金额：
                              <span>
                                {formatNumber(
                                  item.curConfirmTaxAmount,
                                  decimalPlace.Amount_Decimal_Place
                                )}
                              </span>
                            </li>
                            <li>
                              对账未税金额：
                              <span>
                                {formatNumber(
                                  item.curConfirmAmount,
                                  decimalPlace.Amount_Decimal_Place
                                )}
                              </span>
                            </li>
                            <li>
                              税额：
                              <span>
                                {formatNumber(
                                  item.curConfirmTaxAmount -
                                    item.curConfirmAmount,
                                  decimalPlace.Amount_Decimal_Place
                                )}
                              </span>
                            </li>
                            <li>
                              备注：
                              {item.remark}
                            </li>
                            <li>
                              供应商备注：
                              {item.vremark}
                            </li>
                          </ul>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
              {boxState[2] === true && (
                <div className="order-detail-block account">
                  <div className="order-detail-title">
                    <label>收货明细（VMI）合计</label>
                  </div>
                  <ul>
                    <li>
                      <label className="order-detail-label">入库数量合计</label>
                      <div className="order-detail-value">
                        {formatNumber(
                          vmiDeliveryData.storageTotQty,
                          decimalPlace.Quantity_Decimal_Place
                        )}
                      </div>
                    </li>
                    <li>
                      <label className="order-detail-label">含税金额合计</label>
                      <div className="order-detail-value">
                        {formatNumber(
                          vmiDeliveryData.totalCurConfirmTaxAmount,
                          decimalPlace.Amount_Decimal_Place
                        )}
                      </div>
                    </li>
                    <li>
                      <label className="order-detail-label">未税金额合计</label>
                      <div className="order-detail-value">
                        {formatNumber(
                          vmiDeliveryData.totalCurConfirmAmount,
                          decimalPlace.Amount_Decimal_Place
                        )}
                      </div>
                    </li>
                    <li>
                      <label className="order-detail-label">税额合计</label>
                      <div className="order-detail-value">
                        {formatNumber(
                          vmiDeliveryData.totalTax,
                          decimalPlace.Amount_Decimal_Place
                        )}
                      </div>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          )}

        {/* 仓退明细 */}
        {returnData.pageList && !Util.isEmpty(returnData.pageList.list) && (
          <div className="order-detail-box">
            <div className="order-detail-block">
              <div
                className={
                  !boxState[3]
                    ? 'order-detail-title m-more'
                    : 'order-detail-title m-more m-more-open'
                }
              >
                <label>仓退明细</label>
                <i className="icon-down" onClick={() => handleBoxState(3)}></i>
              </div>
              {boxState[3] && (
                <div className="order-detail-list">
                  <ul>
                    {returnData.pageList.list.map((item, index) => (
                      <li className="order-detail-item" key={index}>
                        <span className="lineNo">项次 {item.lineNo}</span>
                        <h4>
                          {item.productCode} - {item.productName}
                        </h4>
                        <p className="mb10">{item.productScale}</p>

                        <ul className="clearfix">
                          <li>
                            退货数量：
                            {formatNumber(
                              item.returnValuationQty,
                              decimalPlace.Quantity_Decimal_Place
                            )}
                          </li>
                          <li>
                            退货单价：
                            {formatNumber(
                              item.poIsContainTax === 1
                                ? item.returnTaxPrice
                                : item.returnPrice,
                              decimalPlace.Price_Decimal_Place
                            )}
                          </li>
                          <li>
                            退货金额：
                            <span>
                              {formatNumber(
                                item.poIsContainTax === 1
                                  ? item.returnTaxPrice
                                  : item.returnAmount,
                                decimalPlace.Amount_Decimal_Place
                              )}
                            </span>
                          </li>
                          <li>退货日期：{formatDate(item.erpReturnDate)}</li>
                          <li>
                            对账单价：
                            {formatNumber(
                              item.poIsContainTax === 1
                                ? item.curReconTaxPrice
                                : item.curReconPrice,
                              decimalPlace.Price_Decimal_Place
                            )}
                            /{item.valuationUnitName}
                          </li>
                          <li>
                            确认单价：
                            {formatNumber(
                              item.poIsContainTax === 1
                                ? item.curConfirmReconTaxPrice
                                : item.curConfirmReconPrice,
                              decimalPlace.Price_Decimal_Place
                            )}
                            /{item.valuationUnitName}
                          </li>
                          <li>
                            是否含税：
                            {item.poIsContainTax === 1 ? '含税' : '不含税'}
                          </li>
                          <li>
                            税率：
                            {item.returnTaxRate
                              ? item.returnTaxRate * 100 + '%'
                              : ''}
                          </li>
                          <li>
                            对账数量：
                            {formatNumber(
                              item.curConfirmValuationQty,
                              decimalPlace.Quantity_Decimal_Place
                            )}
                          </li>
                          <li>
                            对账含税金额：
                            <span>
                              {formatNumber(
                                item.curConfirmTaxAmount,
                                decimalPlace.Amount_Decimal_Place
                              )}
                            </span>
                          </li>
                          <li>
                            对账未税金额：
                            <span>
                              {formatNumber(
                                item.curConfirmAmount,
                                decimalPlace.Amount_Decimal_Place
                              )}
                            </span>
                          </li>
                          <li>
                            税额：
                            <span>
                              {formatNumber(
                                item.curConfirmTaxAmount -
                                  item.curConfirmAmount,
                                decimalPlace.Amount_Decimal_Place
                              )}
                            </span>
                          </li>
                          <li>
                            备注：
                            {item.remark}
                          </li>
                          <li>
                            供应商备注：
                            {item.vremark}
                          </li>
                        </ul>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
            {boxState[3] && (
              <div className="order-detail-block account">
                <div className="order-detail-title">
                  <label>仓退明细合计</label>
                </div>
                <ul>
                  <li>
                    <label className="order-detail-label">退货数量合计</label>
                    <div className="order-detail-value">
                      {formatNumber(
                        returnData.returnTotQty,
                        decimalPlace.Quantity_Decimal_Place
                      )}
                    </div>
                  </li>
                  <li>
                    <label className="order-detail-label">含税金额合计</label>
                    <div className="order-detail-value">
                      {formatNumber(
                        returnData.totalCurReconTaxAmount,
                        decimalPlace.Amount_Decimal_Place
                      )}
                    </div>
                  </li>
                  <li>
                    <label className="order-detail-label">未税金额合计</label>
                    <div className="order-detail-value">
                      {formatNumber(
                        returnData.totalCurReconAmount,
                        decimalPlace.Amount_Decimal_Place
                      )}
                    </div>
                  </li>
                  <li>
                    <label className="order-detail-label">税额合计</label>
                    <div className="order-detail-value">
                      {formatNumber(
                        returnData.totalTax,
                        decimalPlace.Amount_Decimal_Place
                      )}
                    </div>
                  </li>
                </ul>
              </div>
            )}
          </div>
        )}

        {/* 应收折让明细 */}
        {costData.pageList && !Util.isEmpty(costData.pageList.list) && (
          <div className="order-detail-box">
            <div className="order-detail-block">
              <div
                className={
                  !boxState[4]
                    ? 'order-detail-title m-more'
                    : 'order-detail-title m-more m-more-open'
                }
              >
                <label>应收折让明细</label>
                <i className="icon-down" onClick={() => handleBoxState(4)}></i>
              </div>
              {boxState[4] && (
                <div className="order-detail-list">
                  <ul>
                    {costData.pageList.list.map((item, index) => (
                      <li className="order-detail-item" key={index}>
                        <span className="lineNo">项次 {item.lineNo}</span>
                        <ul className="clearfix">
                          <li>
                            折让单号：
                            {item.cosInnerShowNo}
                          </li>
                          <li>
                            单据类型：
                            {item.costBillType === 0 && '费用单'}
                            {item.costBillType === 1 && '费用订单'}
                          </li>
                          <li>
                            折让金额：
                            <span>
                              {formatNumber(
                                item.isContainTax === 1
                                  ? item.costTaxAmount
                                  : item.costAmount,
                                decimalPlace.Amount_Decimal_Place
                              )}
                            </span>
                          </li>
                          <li>
                            对账含税金额：
                            <span>
                              {formatNumber(
                                item.curReconTaxAmount,
                                decimalPlace.Amount_Decimal_Place
                              )}
                            </span>
                          </li>
                          <li>
                            对账未税金额：
                            <span>
                              {formatNumber(
                                item.curReconAmount,
                                decimalPlace.Amount_Decimal_Place
                              )}
                            </span>
                          </li>
                          <li>
                            备注：
                            {item.remark}
                          </li>
                          <li>
                            供应商备注：
                            {item.vremark}
                          </li>
                        </ul>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
            {boxState[4] && (
              <div className="order-detail-block account">
                <div className="order-detail-title">
                  <label>应收折让明细合计</label>
                </div>
                <ul>
                  <li>
                    <label className="order-detail-label">含税金额</label>
                    <div className="order-detail-value">
                      {formatNumber(
                        costData.totalCurReconTaxAmount,
                        decimalPlace.Amount_Decimal_Place
                      )}
                    </div>
                  </li>
                  <li>
                    <label className="order-detail-label">未税金额</label>
                    <div className="order-detail-value">
                      {formatNumber(
                        costData.totalCurReconAmount,
                        decimalPlace.Amount_Decimal_Place
                      )}
                    </div>
                  </li>
                </ul>
              </div>
            )}
          </div>
        )}

        {/* 预付款明细 */}
        {prepayData.pageList && !Util.isEmpty(prepayData.pageList.list) && (
          <div className="order-detail-box">
            <div className="order-detail-block">
              <div
                className={
                  !boxState[5]
                    ? 'order-detail-title m-more'
                    : 'order-detail-title m-more m-more-open'
                }
              >
                <label>预付款明细</label>
                <i className="icon-down" onClick={() => handleBoxState(5)}></i>
              </div>
              {boxState[5] && (
                <div className="order-detail-list">
                  <ul>
                    {prepayData.pageList.list.map((item, index) => (
                      <li className="order-detail-item" key={index}>
                        <span className="lineNo">项次 {item.lineNo}</span>
                        <ul className="clearfix">
                          <li>
                            预付款单号：
                            {item.ppmXkNo}
                          </li>
                          <li>
                            预付款金额：
                            <span>
                              {formatNumber(
                                item.prepayAmount,
                                decimalPlace.Amount_Decimal_Place
                              )}
                            </span>
                          </li>
                          <li>
                            对账抵扣总金额：
                            <span>
                              {formatNumber(
                                item.alreadyDeductionAmount,
                                decimalPlace.Amount_Decimal_Place
                              )}
                            </span>
                          </li>
                          <li>
                            抵扣金额：
                            <span>
                              {formatNumber(
                                item.curReconAmount,
                                decimalPlace.Amount_Decimal_Place
                              )}
                            </span>
                          </li>
                          <li>
                            确认金额：
                            <span>
                              {formatNumber(
                                item.curConfirmReconAmount,
                                decimalPlace.Amount_Decimal_Place
                              )}
                            </span>
                          </li>
                          <li>
                            备注：
                            {item.remark}
                          </li>
                          <li>
                            供应商备注：
                            {item.vremark}
                          </li>
                        </ul>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
            {boxState[5] && (
              <div className="order-detail-block account">
                <div className="order-detail-title">
                  <label>预付款明细合计</label>
                </div>
                <ul>
                  <li>
                    <label className="order-detail-label">抵扣金额</label>
                    <div className="order-detail-value">
                      {formatNumber(
                        prepayData.totalDeductibleAmount,
                        decimalPlace.Amount_Decimal_Place
                      )}
                    </div>
                  </li>
                  <li>
                    <label className="order-detail-label">确认金额</label>
                    <div className="order-detail-value">
                      {formatNumber(
                        prepayData.totalConfirmAmount,
                        decimalPlace.Amount_Decimal_Place
                      )}
                    </div>
                  </li>
                </ul>
              </div>
            )}
          </div>
        )}

        {/* 对账单合计 */}
        <div className="order-detail-block account">
          <div className="order-detail-title">
            <label>对账单合计</label>
          </div>
          <div className="m-flex-box">
            <div className="m-flex-item">
              <table className="statement-total">
                <tbody>
                  <tr>
                    <td>出货含税金额：</td>
                    <td>
                      <span>
                        {formatNumber(
                          amounts.deliveryRecoTaxAmount,
                          decimalPlace.Amount_Decimal_Place
                        )}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>VMI含税金额：</td>
                    <td>
                      <span>
                        {formatNumber(
                          amounts.vmiDeliveryRecoTaxAmount,
                          decimalPlace.Amount_Decimal_Place
                        )}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>退货含税金额：</td>
                    <td>
                      <span>
                        {formatNumber(
                          amounts.returnRecoTaxAmount,
                          decimalPlace.Amount_Decimal_Place
                        )}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>费用含税金额：</td>
                    <td>
                      <span>
                        {formatNumber(
                          amounts.costRecoTaxAmount,
                          decimalPlace.Amount_Decimal_Place
                        )}
                      </span>
                    </td>
                  </tr>
                  <tr className="udline">
                    <td>预付含税金额：</td>
                    <td>
                      <span>
                        {formatNumber(
                          amounts.prepayRecoAmount,
                          decimalPlace.Amount_Decimal_Place
                        )}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>对账含税金额：</td>
                    <td>
                      <span>
                        {formatNumber(
                          amounts.totalRecoTaxAmount,
                          decimalPlace.Amount_Decimal_Place
                        )}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>未税金额：</td>
                    <td>
                      <span>
                        {formatNumber(
                          amounts.totalRecoAmount,
                          decimalPlace.Amount_Decimal_Place
                        )}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>税额：</td>
                    <td>
                      <span>
                        {formatNumber(
                          amounts.tax,
                          decimalPlace.Amount_Decimal_Place
                        )}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            {(self.isPurchase || [3, 5].includes(detail.status)) && (
              <div className="m-flex-item">
                <table className="statement-total">
                  <tbody>
                    <tr>
                      <td>确认出货金额：</td>
                      <td>
                        <span
                          className={
                            amounts.deliveryConfirmTaxAmount !==
                            amounts.deliveryRecoTaxAmount
                              ? 'red'
                              : ''
                          }
                        >
                          {formatNumber(
                            amounts.deliveryConfirmTaxAmount,
                            decimalPlace.Amount_Decimal_Place
                          )}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>出货VMI金额：</td>
                      <td>
                        <span
                          className={
                            amounts.vmiDeliveryConfimTaxAmount !==
                            amounts.vmiDeliveryRecoAmount
                              ? 'red'
                              : ''
                          }
                        >
                          {formatNumber(
                            amounts.vmiDeliveryConfimTaxAmount,
                            decimalPlace.Amount_Decimal_Place
                          )}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>确认退货金额：</td>
                      <td>
                        <span
                          className={
                            amounts.returnConfirmTaxAmount !==
                            amounts.returnRecoTaxAmount
                              ? 'red'
                              : ''
                          }
                        >
                          {formatNumber(
                            amounts.returnConfirmTaxAmount,
                            decimalPlace.Amount_Decimal_Place
                          )}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>确认费用金额：</td>
                      <td>
                        <span
                          className={
                            amounts.costConfirmTaxAmount !==
                            amounts.costRecoTaxAmount
                              ? 'red'
                              : ''
                          }
                        >
                          {formatNumber(
                            amounts.costConfirmTaxAmount,
                            decimalPlace.Amount_Decimal_Place
                          )}
                        </span>
                      </td>
                    </tr>
                    <tr className="udline">
                      <td>预付抵扣金额：</td>
                      <td>
                        <span
                          className={
                            amounts.prepayConfimAmount !==
                            amounts.prepayRecoAmount
                              ? 'red'
                              : ''
                          }
                        >
                          {formatNumber(
                            amounts.prepayConfimAmount,
                            decimalPlace.Amount_Decimal_Place
                          )}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>确认对账金额：</td>
                      <td>
                        <span>
                          {formatNumber(
                            amounts.totalConfirmTaxAmount,
                            decimalPlace.Amount_Decimal_Place
                          )}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>未税金额：</td>
                      <td>
                        <span
                          className={
                            amounts.totalConfirmTaxAmount !==
                            amounts.totalRecoTaxAmount
                              ? 'red'
                              : ''
                          }
                        >
                          {formatNumber(
                            amounts.totalConfirmAmount,
                            decimalPlace.Amount_Decimal_Place
                          )}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>税额：</td>
                      <td>
                        <span
                          className={
                            amounts.totalConfirmAmount !==
                            amounts.totalRecoAmount
                              ? 'red'
                              : ''
                          }
                        >
                          {formatNumber(
                            amounts.confirmTax,
                            decimalPlace.Amount_Decimal_Place
                          )}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* 采购方操作 */}
      {self.isPurchase && (
        <div className="wrap m-flex-box fixed-bottom">
          {User.checkAuth('10040104') &&
            detail.status === 1 &&
            workflow.data &&
            workflow.data['reco_cfm_5'].complete && (
              <Button
                type="default"
                onClick={() => {
                  handleConfirm();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                确认
              </Button>
            )}
          {User.checkAuth('10040105') &&
            companyParams['Statement_Qty_Cfm'] &&
            detail.status === 6 &&
            detail.statementOriginator === 0 && (
              <Button
                type="default"
                onClick={() => {
                  confirmQty();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                数量审核
              </Button>
            )}
          {User.checkAuth('10040103') &&
            [1, 6].includes(detail.status) &&
            detail.statementOriginator === 0 && (
              <Button
                type="default"
                onClick={() => {
                  handleReject();
                }}
                className="m-flex-item u-btn u-btn_warn"
              >
                退回
              </Button>
            )}
          {User.checkAuth('10040102') &&
            [0, 2, 4].includes(detail.status) &&
            detail.statementOriginator === 1 && (
              <Button
                type="default"
                onClick={() => {
                  publish();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                确认发出
              </Button>
            )}
          {User.checkAuth('10040102') &&
            [0].includes(detail.status) &&
            detail.statementOriginator === 1 && (
              <Button
                type="default"
                onClick={() => {
                  handleDelete();
                }}
                className="m-flex-item u-btn u-btn_warn"
              >
                删除
              </Button>
            )}
          {User.checkAuth('10040102') &&
            [1, 7].includes(detail.status) &&
            detail.statementOriginator === 1 && (
              <Button
                type="default"
                onClick={() => {
                  handleRecall();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                撤回
              </Button>
            )}
          {User.checkAuth('10040102') &&
            [2, 4, 5].includes(detail.status) &&
            detail.statementOriginator === 1 &&
            detail.invoiceStatus === 0 && (
              <Button
                type="default"
                onClick={() => {
                  handleCancel();
                }}
                className="m-flex-item u-btn u-btn_warn"
              >
                作废
              </Button>
            )}
        </div>
      )}

      {/* 供应商操作 */}
      {!self.isPurchase && (
        <div className="wrap m-flex-box fixed-bottom">
          {User.checkAuth('20040102') &&
            [0, 2, 4].includes(detail.status) &&
            detail.statementOriginator === 0 && (
              <Button
                type="default"
                onClick={() => {
                  publish();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                确认发出
              </Button>
            )}
          {User.checkAuth('20040102') &&
            detail.status === 0 &&
            detail.statementOriginator === 0 && (
              <Button
                type="default"
                onClick={() => {
                  handleDelete();
                }}
                className="m-flex-item u-btn u-btn_warn"
              >
                删除
              </Button>
            )}
          {User.checkAuth('20040104') &&
            detail.status === 1 &&
            detail.statementOriginator === 0 &&
            canRecall && (
              <Button
                type="default"
                onClick={() => {
                  handleRecall();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                撤回
              </Button>
            )}
          {User.checkAuth('20040105') &&
            [2, 4, 5].includes(detail.status) &&
            detail.statementOriginator === 0 &&
            detail.invoiceStatus === 0 && (
              <Button
                type="default"
                onClick={() => {
                  handleCancel();
                }}
                className="m-flex-item u-btn u-btn_warn"
              >
                作废
              </Button>
            )}
          {User.checkAuth('20040102') && [7].includes(detail.status) && (
            <Button
              type="default"
              onClick={() => {
                handleConfirm();
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              确认
            </Button>
          )}
          {User.checkAuth('20040102') &&
            [7].includes(detail.status) &&
            ![1, 2].includes(detail.invoiceStatus) && (
              <Button
                type="default"
                onClick={() => {
                  handleReject();
                }}
                className="m-flex-item u-btn u-btn_warn"
              >
                退回
              </Button>
            )}
        </div>
      )}

      <Modal></Modal>
    </div>
  );
}

StatementDetailDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StatementDetailDetail);
